import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowRight, FaReact, FaNodeJs, FaWordpress, FaSearch, FaShoppingCart, FaCode, FaMobileAlt, FaPaintBrush, FaRocket, FaCogs } from 'react-icons/fa';
import { SiMongodb, SiElementor, SiWoo } from 'react-icons/si';
import API from '../api/axios';

const serviceIcons = {
  'web development': <FaCode />, 'website': <FaCode />, 'react': <FaReact />,
  'mern': <FaReact />, 'node': <FaNodeJs />, 'wordpress': <FaWordpress />,
  'elementor': <SiElementor />, 'woocommerce': <SiWoo />, 'ecommerce': <FaShoppingCart />,
  'e-commerce': <FaShoppingCart />, 'seo': <FaSearch />, 'mobile': <FaMobileAlt />,
  'design': <FaPaintBrush />, 'mongodb': <SiMongodb />, 'api': <FaCogs />,
  'speed': <FaRocket />, 'performance': <FaRocket />,
};

const getIcon = (title) => {
  const lower = title.toLowerCase();
  for (const [key, icon] of Object.entries(serviceIcons)) {
    if (lower.includes(key)) return icon;
  }
  return <FaCode />;
};

const cardGradients = [
  'linear-gradient(135deg, #6c63ff, #3b3994)', 'linear-gradient(135deg, #ff6584, #d63384)',
  'linear-gradient(135deg, #00d2ff, #0080b3)', 'linear-gradient(135deg, #ffc371, #ff5f6d)',
  'linear-gradient(135deg, #4caf50, #2e7d32)', 'linear-gradient(135deg, #9c27b0, #6a1b9a)',
];

const defaultServices = [
  { _id: '1', title: 'MERN Stack Development', shortDescription: 'Full-stack web applications with MongoDB, Express, React & Node.js', price: 500 },
  { _id: '2', title: 'WordPress Development', shortDescription: 'Custom WordPress websites with Elementor, themes & plugins', price: 300 },
  { _id: '3', title: 'WooCommerce Store', shortDescription: 'Complete e-commerce solutions with payment integration', price: 400 },
  { _id: '4', title: 'SEO Optimization', shortDescription: 'On-page, off-page, technical SEO & link building services', price: 200 },
  { _id: '5', title: 'React.js Frontend', shortDescription: 'Modern, responsive React applications with beautiful UI', price: 350 },
  { _id: '6', title: 'API Development', shortDescription: 'RESTful API design with Node.js, Express & MongoDB', price: 250 },
];

const FeaturedServices = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    API.get('/services?featured=true').then(r => setServices(r.data)).catch(() => {});
  }, []);

  const displayServices = services.length > 0 ? services.slice(0, 6) : defaultServices;

  return (
    <section className="featured-services section" id="services-preview">
      <div className="container">
        <div className="section-title"><h2>My Services</h2><p>Professional solutions for your business</p></div>
        <div className="services-grid">
          {displayServices.map((service, idx) => (
            <motion.div key={service._id} className="service-card"
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.4, delay: idx * 0.1 }}
              whileHover={{ y: -10, transition: { duration: 0.2 } }}>
              <div className="service-icon-wrapper" style={{ background: cardGradients[idx % cardGradients.length] }}>
                <span className="service-icon">{getIcon(service.title)}</span>
              </div>
              <h3>{service.title}</h3>
              <p>{service.shortDescription || service.description?.substring(0, 100)}</p>
              <div className="service-card-footer">
                <span className="service-price">From ${service.discountPrice || service.price}</span>
                <Link to={`/services/${service._id}`} className="service-link">
                  Details <FaArrowRight />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/services" className="btn btn-primary">View All Services <FaArrowRight /></Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedServices;
